"use strict";

import Vue from 'vue';
import axios from "axios";
import router from '@/router'
import store from '@/store'
import cookie from "js-cookie";
import {
  Message
} from 'element-ui'
import { API } from './config'
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const tip = msg => {
  // Message().close();
  Message({
    message: msg,
    type: 'error',
    offset: 100
  })
}

const toLogin = () => {
  router.replace({
    path: '/login'
    // query: {
    //   redirect: router.currentRoute.fullPath
    // }
  })
}

var login_redirect = 0;
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    case 400:
      if (other) {
        tip(other)
      } else {
        tip('操作失败，请重试')
      }
      break
    case 401:
      tip('您暂无操作权限')
      break
    case 402:
      if (other) {
        // tip(other)
      } else {
        tip('操作失败，请重试')
      }
      break
    case 300:
      // http://127.0.0.1:8002/index/wantOrder
      if(!login_redirect){
        login_redirect = 1
        setTimeout(() => {
          localStorage.removeItem('USERToken')
          localStorage.removeItem('userInfo')
          store.commit('global/set_userInfo', '')
          localStorage.removeItem('locale')
          localStorage.removeItem('selCheck')
          localStorage.removeItem('role')
          localStorage.removeItem("shareCode");
          localStorage.removeItem("ChatToken");
          localStorage.removeItem("ChatUser");
          localStorage.removeItem("loginTime");
          // localStorage.removeItem("ChatTokenTime");
          cookie.remove("user_id");
          let uri = window.location.search.indexOf('?u=')>-1 ? window.location.search : encodeURIComponent(window.location.pathname+window.location.search);
          router.push({ path: '/index/login', query:{u:uri}})
          login_redirect = 0
        }, 1000)
        tip('账号过期，请重新登录')
      }
      break
    case 500:
      tip('网络错误')
      break
    default:
      tip(other)
    // console.log(other)
  }
}

// let baseUrl = ''
// if (process.env.NODE_ENV =='development') {
//   // 开发环境的url
//   baseUrl = API.DEV_SERVER
//   console.log("现在是本地开发环境"+baseUrl);
// } else if (process.env.NODE_ENV == 'production') {
//   // 正式环境的 request url
//   baseUrl = API.PRO_SERVER
// }
var protocol = location.protocol;
let config = {
  // fxx 2023-8-19 使用自动域名，不需要再指定
  baseURL: protocol == 'http:' ? process.env.VUE_APP_BASE_API : process.env.VUE_APP_BASES_API,
  // withCredentials: true, // Check cross-site Access-Control
  timeout: 60 * 1000, // Timeout
  headers: {

    "Accept": "application/json",
    "Accept-Language": localStorage.getItem("locale") ? localStorage.getItem("locale") : navigator.language
  }
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    let token = localStorage.getItem('USERToken')
    //聊天token
    let chat_token = localStorage.getItem('ChatToken')
    let goPath = 'user'
    let role = localStorage.getItem('role')
    if (role) {
      role == 1 ? goPath = 'user' : role == 2 ? goPath = 'insp' : goPath = ''
    }
    //console.log(config,"===config====");
    config.headers['token'] = token ? token : '';
    //console.log(config.url.indexOf("http://"),"===indexOf=="+config.url);
    if (config.url.indexOf("http://") != -1 || config.url.indexOf("https://") != -1 || config.url.indexOf("chat/") != -1) {
      config.headers['token'] = chat_token ? chat_token : '';
    }
    /* if(config.data){
       if(config.data.indexOf("auto_token=")!=-1){
         var auto_token=config.data.replace("auto_token=","");
         config.headers['token'] =
       }
     }*/
    //config.headers['token'] = chat_token ? chat_token : ''
    config.headers['iden'] = goPath
    config.headers['device'] = 'web'
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // console.log(response,"===response===");
    // Do something with response data
    if (response.status == 200) {
      if (response.data.code && response.data.code != 200 && response.data.code != 20000 && response.data.code != -1) {
        if (response.data.msg != '支付失败') {
          errorHandle(response.data.code, response.data.msg)
        }
      } else {
        return response;
      }
    }
    return response;
  },
  function (error) {
    // Do something with response error
    // 错误提示
    console.log(error)
    // errorHandle(error.status, error.data.msg)
    return Promise.reject(error);
  }
);

Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)
Vue.prototype.$http = axios;
export const request = _axios

export default Plugin;
